<template>

  <v-container fluid>
    <v-row class="text-center">
      <v-col class="text-h4 red--text">
        {{customer.name}} has an open loan and is ineligible for another Salary Advance loan.
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {

  props: ['customer', 'instrumentId'],

}
</script>
